import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import { fuseDark, skyBlue } from './colors';

// Create a theme instance.
const theme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: fuseDark[700],
			light: fuseDark[500],
			dark: fuseDark[900],
			contrastText: '#fff'
		},
		secondary: {
			main: skyBlue[500],
			light: skyBlue[300],
			dark: skyBlue[700],
			contrastText: '#000'
		},
		background: {
			paper: '#FFFFFF',
			default: '#F7F7F7'
		},
		error: {
			main: red[500],
			light: red[300],
			dark: red[700],
			contrastText: '#fff'
		},
		text: {
			primary: '#000000',
			secondary: '#666666'
		}
	},
	status: {
		danger: 'orange'
	},
	components: {
		MuiButton: {
			defaultProps: {
				disableElevation: true,
				disableRipple: false
			},
			styleOverrides: {
				root: {
					textTransform: 'none',
					borderRadius: 4,
					padding: '8px 16px'
				},
				contained: {
					boxShadow: 'none',
					'&:hover': {
						boxShadow: 'none'
					}
				},
				outlined: {
					borderWidth: 1,
					'&:hover': {
						borderWidth: 1
					}
				}
			}
		},
		MuiCssBaseline: {
			styleOverrides: {
				body: {
					backgroundColor: '#F7F7F7',
					margin: 0,
					padding: 0
				}
			}
		}
	},
	typography: {
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif'
		].join(','),
		button: {
			textTransform: 'none'
		}
	},
	shape: {
		borderRadius: 4
	},
});

export default theme;
